import { render, staticRenderFns } from "./FooterAdmin.vue?vue&type=template&id=97ca83a2&scoped=true"
import script from "./FooterAdmin.vue?vue&type=script&lang=js"
export * from "./FooterAdmin.vue?vue&type=script&lang=js"
import style0 from "./FooterAdmin.vue?vue&type=style&index=0&id=97ca83a2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97ca83a2",
  null
  
)

export default component.exports